import { useTranslation } from 'next-i18next';
import * as yup from 'yup';

import { IApprovals } from '@/modules/settings/approvals/types';
export const useApprovals = () => {
  const { t } = useTranslation();
  const addApproverSchema: yup.SchemaOf<IApprovals.IApproverItemSchema> = yup
    .object()
    .shape({
      approverId: yup.number().required(t('this-field-is-required')).nullable(),
      canEdit: yup.mixed().oneOf([1, 0]).required(t('this-field-is-required')),
    });

  const updateApproversSchema: yup.SchemaOf<IApprovals.IUpdateApproverSchema> =
    yup.object().shape({
      approvalPathId: yup.number().required(),
      entityId: yup.number().required(),
      approvers: yup
        .array()
        .of(addApproverSchema.required(t('this-field-is-required')))
        .required(t('this-field-is-required'))
        .min(1, t('this-field-is-required')),
    });

  return { updateApproversSchema, addApproverSchema };
};
